import { useState, useEffect } from "react";
import MLRView from "@/components/MLRView";
import axios from "axios";
import { Annotation } from "@/types/types";
import { useAuth } from "@/components/auth/AuthContext";
import { fetchAuthSession } from "aws-amplify/auth";
import { useBrandStore } from "@/stores/brandStore";
import { useProjects } from "@/stores/projectStore";
const MLRPage = () => {
    const [annotations, setAnnotations] = useState<Annotation[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const { isAuthenticated } = useAuth();
    const { selectedBrand } = useBrandStore();
    const [projectId, setProjectId] = useState<string | null>(null);

    useEffect(() => {
        // Get project ID from URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get("id");
        setProjectId(id);
    }, []);

    const { projects, isLoading: isProjectsLoading } = useProjects();

    useEffect(() => {
        const fetchAnnotations = async () => {
            try {
                const useMockAuthentication =
                    import.meta.env.VITE_USE_MOCK_AUTH === "true";
                let idToken;
                if (useMockAuthentication) {
                    idToken = "123";
                } else {
                    const { idToken: token } =
                        (await fetchAuthSession()).tokens ?? {};
                    idToken = token;
                }

                if (!idToken) {
                    throw new Error("No authentication token found");
                }
                if (!projectId) {
                    throw new Error("No project ID found");
                }
                if (!selectedBrand) {
                    throw new Error("No brand selected");
                }

                const response = await axios.get<Annotation[]>(
                    `${import.meta.env.VITE_API_GATEWAY_URL}/get-annotations`,
                    {
                        headers: {
                            Authorization: `Bearer ${idToken.toString()}`,
                        },
                        params: {
                            brandId: selectedBrand,
                            projectId: projectId,
                        },
                    }
                );

                setAnnotations(response.data);
                setIsLoading(false);
            } catch (err) {
                setError("Failed to fetch annotations");
                setIsLoading(false);
                console.error("Error fetching annotations:", err);
            }
        };

        if (isAuthenticated && projectId && selectedBrand) {
            fetchAnnotations();
        }
    }, [isAuthenticated, projectId, selectedBrand]);

    if (isProjectsLoading) {
        return <div>Loading...</div>;
    }

    if (isLoading) return <div>Loading annotations...</div>;
    if (error) return <div>Error: {error}</div>;
    const project = projects.find((p) => p.id === Number(projectId));
    if (!project) return <div>Project not found</div>;
    return (
        <MLRView
            pdfUrl={project.marketingContentPath[0]}
            annotations={annotations}
        />
    );
};

export default MLRPage;
